import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { AppState } from "../App";
import { Link } from "react-router-dom";
import { useWeb3 } from "../contexts/Web3Context";
import NetworkStatus from "./NetworkStatus";
import { FaSignOutAlt } from "react-icons/fa";

const Navbar = () => {
  const useAppState = useContext(AppState);
  const { isWalletConnected, isContractReady, provider } = useWeb3();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isContractReady && isWalletConnected) {
      setIsLoggedIn(true);
    }
  }, [isContractReady, isWalletConnected]);

  return (
    <header className="max-w-screen-2xl mx-auto sticky top-0 w-full z-50">
      <nav className="shadow-md py-2.5 bg-[#181a1e] rounded-lg">
        <div className="flex flex-wrap items-center justify-between max-w-screen-2xl px-8 mx-auto">
          <Link to={"/"} className="flex items-center">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-2xl font-bold text-black dark:text-white cursor-pointer"
              onClick={() => scrollToSection("home")}
            >
               <div className="flex items-center">
                <img
                  src="logo.png"
                  className="h-6 mr-0 sm:h-6"
                  alt="Landwind Logo"
                />
                <span className="text-primary mb-1">bnb</span>
              </div>
            </motion.div>
          </Link>
          <div className="flex items-center lg:order-2 gap-2">
            <NetworkStatus provider={provider} />
            {isLoggedIn ? (
              <div className="flex items-center gap-4">               
                <button onClick={() => useAppState.navigate("/")}>
                  <FaSignOutAlt className="w-6 h-6 text-red-500" />
                </button>
              </div>
            ) : (
              <button
                onClick={() => useAppState.navigate("/dashboard")}
                className="h-[32px] flex items-center justify-center bg-primary text-white px-3 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
              >
                Connect Wallet
              </button>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
